export default {
  header: {
    height: 40,
  },
  devices: {
    result: {
      padding: 16,
    },
  },
};
